export class CreateFleetDefinitionRequest {
    accountId?: string;
    fleetKind?: string;
    fleetType?: string;    
    imageName?: string;
    instanceType?: string;
    desiredInstances?: number;
    minCapacity?: number;
    maxCapacity?: number;
    disconnectTimeoutInSeconds?: number;
    idleDisconnectTimeoutInSeconds?: number;
    maxUserDurationInSeconds?: number;
    scaleOutCooldownInSeconds?: number;
    scaleInCooldownInSeconds?: number;
    scaleOutAdjustment?: number;
    scaleInAdjustment?: number;
    minAvailableCapacityAlarmThreshold?: number;
    minAvailableCapacityAlarmEvaluationPeriods?: number;
    maxAvailableCapacityAlarmThreshold?: number;
    maxAvailableCapacityAlarmEvaluationPeriods?: number;
    usesLegacySessionContext?: boolean;
}